// FIXME: copied from ../../explore/explore.component.ts
//        Should we group constants in a file in /shared ?
export const DEFAULT_SEARCH_DISTANCE = 50000;
